import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PrepaidClinicSupply } from '@models/prepaid-clinic-supply';

@Component({
  selector: 'app-prepaid-clinic-supplies-list',
  templateUrl: './prepaid-clinic-supplies-list.component.html',
  styleUrls: ['./prepaid-clinic-supplies-list.component.less'],
})
export class PrepaidClinicSuppliesListComponent {
  private _prepaidClinicSupplies: PrepaidClinicSupply[] = [];

  @Input() showHeader = true;
  @Input() showRedeemButton = false;
  @Input() eligibleObservationListIds: number[] = [];
  @Input() set prepaidClinicSupplies(value: PrepaidClinicSupply[] | null | undefined) {
    this._prepaidClinicSupplies = value ?? [];
  }
  get prepaidClinicSupplies(): PrepaidClinicSupply[] {
    return this._prepaidClinicSupplies;
  }
  @Input() loading = false;
  @Output() redeemSupply = new EventEmitter<PrepaidClinicSupply>();

  canRedeem(supply: PrepaidClinicSupply): boolean {
    if (!supply) {
      return false;
    }
    return this.eligibleObservationListIds?.includes(supply.observationListId) ?? false;
  }

  onRedeem(supply: PrepaidClinicSupply) {
    if (!this.canRedeem(supply)) {
      return;
    }
    this.redeemSupply.emit(supply);
  }

  trackByObservationListId(_: number, supply: PrepaidClinicSupply) {
    return supply?.observationListId;
  }
}
